import React, { FC } from "react";
import format from "date-fns/format";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import eachMinuteOfInterval from "date-fns/eachMinuteOfInterval";
import nb from "date-fns/locale/nb";

import { Select } from "../Partials/Select";
import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { newDateInOsloTimeZone } from "../../Booking/Helpers/timeZoneHelpers";

interface TimeSelectProps {
  onChange: (item: string) => void;
  disabled?: boolean;
}

export const TimeSelect: FC<TimeSelectProps> = (props) => {
  const { onChange, disabled = false } = props;

  const { inputs } = useInsuranceLabels();

  const items = eachMinuteOfInterval(
    {
      start: setMinutes(setHours(newDateInOsloTimeZone(), 0), 0),
      end: setMinutes(setHours(newDateInOsloTimeZone(), 23), 59),
    },
    { step: 30 }
  );

  const parsedItems = items.map((item) => format(item, "p", { locale: nb }));

  const renderItem = (item: string) => item;

  return (
    <Select<string>
      items={parsedItems}
      onSelectionChange={onChange}
      renderItemInList={renderItem}
      itemToString={renderItem}
      label={inputs.timeLabel}
      backgroundVariant="blue-light"
      placeholder={inputs.timePlaceholder}
      className="bookingTime"
      disabled={disabled}
    />
  );
};
